import { useQuery } from "@tanstack/react-query";
import { SocialPostTypeWithFeedback } from "../types";
import { axiosReq } from "@/lib/axios";

export const useGetPostsWithFeedback = () => {

  const request = async (): Promise<{
    posts: SocialPostTypeWithFeedback[]
  }> => {
    const response = await axiosReq.get('/api/landing/get-feedback/')
    return response.data
  }

  const { data: feedbackData } = useQuery({
    queryKey: ["feedback-posts"],
    queryFn: request
  })

  return { feedbackData }
}
